module.exports = __webpack_public_path__ + "img/background-active.11e62e5e.png";